var map = {
	"./logo-acompanhamentoprojetos.svg": "3e78",
	"./logo-administracao.svg": "5e8e",
	"./logo-avaliacao.svg": "711f",
	"./logo-casa-bco.svg": "3c1d",
	"./logo-casa-bco2.svg": "f2b5",
	"./logo-casa.svg": "7a43",
	"./logo-colegiados.svg": "3035",
	"./logo-colegiados1.svg": "e5e4",
	"./logo-legisla.svg": "5eed6",
	"./logo-legislaPublico.svg": "b462",
	"./logo-movimentacao.svg": "2da8",
	"./logo-participagoias.svg": "c06f",
	"./logo-portal-bco.svg": "f761",
	"./logo-portal.svg": "5eb8",
	"./logo-revisa.svg": "4316",
	"./logo-sgu.svg": "59da",
	"./logo-siga.svg": "fecf",
	"./logo-tanalei.svg": "3c83",
	"./logo-tanaleiPublico.svg": "9ba0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c86f";